import Vue from 'vue'

export default {
  namespaced: true,
  state: () => ({
    list: Object.freeze([]),
    areas: Object.freeze([])
  }),
  getters: {
    list: state => state.list,
    map: state => state.list.reduce((map, envFactor) => {
      let {siteId} = envFactor
      let envFactorMap = map[siteId]

      if (!envFactorMap) {
        envFactorMap = map[siteId] = {}
      }

      envFactorMap[envFactor.id] = envFactor

      return map
    }, {}),
    areas: state => state.areas,
    areaMap: state => state.areas.reduce((map, area) => {
      let {siteId} = area
      let areaMap = map[siteId]

      if (!areaMap) {
        areaMap = map[siteId] = {}
      }

      areaMap[area.id] = area

      return map
    }, {})
  },
  mutations: {
    list (state, list) {
      state.list = Object.freeze(list)
    },
    areas (state, areas) {
      state.areas = Object.freeze(areas)
    }
  },
  actions: {
    request ({commit}) {
      return Promise.all([
        Vue.prototype.$api.EnvFactor.getList(),
        Vue.prototype.$api.EnvFactor.getConfig()
      ]).then(([list, areas]) => {
        commit('list', list)
        commit('areas', areas)
      }).catch(console.error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/EnvFactor.js